import { FieldDynamicListEntity } from '@smx-ui-common/field-dynamic-list-entity';
import { Button, Flex, Form } from 'antd';
import { Suspense } from 'react';

import { drawingSetFragment$key } from '../graphql/__generated__/drawingSetFragment.graphql';
import { DrawingSetStatusInput } from '../graphql/__generated__/drawingSetVersionChangeStatusMutation.graphql';
import { drawingSetVersionFragment$data } from '../graphql/__generated__/drawingSetVersionFragment.graphql';
import { storeDrawingsModel } from '../model/store-drawings-model';
import { DrawingSetVersionModelType } from '../model/types';
import { ButtonPublish } from './button-publish';
import { DrawingSetVersionSelectOption } from './drawing-set-version-select-option';
import { LoaderFormDrawingSetVersion } from './loader-form-drawing-set-version';

interface TableDrawingSetSheetPanelProps {
    drawingSetId: string;
    versionDate: number;
    setCurrentVersionDate: React.Dispatch<React.SetStateAction<number>>;
    setCurrentStatusDrawingSetVersion?: React.Dispatch<React.SetStateAction<DrawingSetStatusInput | null>>;
}

export const TableDrawingSetSheetPanel: React.FC<TableDrawingSetSheetPanelProps> = ({
    drawingSetId,
    versionDate,
    setCurrentVersionDate,
    setCurrentStatusDrawingSetVersion,
}) => {
    const [form] = Form.useForm();
    const values = Form.useWatch([], { form, preserve: true });

    return (
        <Flex justify={'space-between'} flex={1} style={{ margin: '0 10px 0px' }}>
            <Flex align={'center'} gap={5}>
                <Form name={`drawingSetVersion-${drawingSetId}`} layout={'inline'} form={form} autoComplete="off">
                    {versionDate && (
                        <Suspense>
                            <LoaderFormDrawingSetVersion drawingSetId={drawingSetId} versionDate={versionDate} />
                        </Suspense>
                    )}
                    <FieldDynamicListEntity<DrawingSetVersionModelType, any, drawingSetVersionFragment$data>
                        model={storeDrawingsModel.drawingSetVersion}
                        listName={'drawingSetVersionList'}
                        listFieldName={['versionDate']}
                        field={storeDrawingsModel.drawingSetVersion.schema.field.versionDate}
                        style={{ width: 250 }}
                        input={{
                            filter: {
                                drawingSetId: { operator: 'EQ', value: drawingSetId },
                            },
                            orderBy: {
                                versionDate: 'ASC',
                            },
                        }}
                        renderLabel={(node: drawingSetFragment$key) => <DrawingSetVersionSelectOption node={node} />}
                        onSelect={(value) => {
                            setCurrentVersionDate(+value.split(':')[1]);
                        }}
                    />
                </Form>
            </Flex>
            {values?.versionDate && (
                <Suspense fallback={<Button loading={true}>{'Publish'}</Button>}>
                    <ButtonPublish
                        drawingSetVersionId={values.versionDate}
                        setCurrentStatusDrawingSetVersion={setCurrentStatusDrawingSetVersion}
                    />
                </Suspense>
            )}
        </Flex>
    );
};
